import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NewMenuItem from '../NewMenuItem';
import placeholder from '../../assets/images/placeholder.jpg';
import './main.css';

class MenuItems extends Component {
  constructor(props) {
    super(props);
    this.state = {
      popularMenuItems: [],
      renderedAll: false,
    };
  }

  componentDidMount() {
    this._isMount = true;

    if (this.props.populars) {
      this._isMount &&
        this.setState({
          popularMenuItems: this.props.populars,
        });
    }
  }

  componentWillReceiveProps(props) {
    if (props.populars) {
      this._isMount &&
        this.setState({
          popularMenuItems: props.populars,
        });
    }
  }

  componentWillUnmount() {
    this._isMount = false;
  }

  getPriceForDisplay = (item) => {
    if (item.selectedSizes) {
      if (this.props.filterCat) {
        if (item.isAvailable) {
          let featureSizes = item.selectedSizes.filter((obj) => {
            return obj._id === this.props.sizeID;
          });
          if (featureSizes.length > 0) {
            return (
              featureSizes[0].name.substring(0, 1) +
              ' ' +
              Number(featureSizes[0].price).toFixed(2)
            );
          } else return Number(item.selectedSizes[0].price).toFixed(2);
        } else {
          return 'Sold Out';
        }
      } else {
        if (item.isAvailable) {
          let featureSizes = item.selectedSizes.filter((obj) => {
            return obj.isFeaturedSize === true;
          });
          if (featureSizes.length > 0) {
            return featureSizes[0].isAbbreviationShow
              ? featureSizes[0].name.substring(0, 1) +
                  ' ' +
                  Number(featureSizes[0].price).toFixed(2)
              : Number(featureSizes[0].price).toFixed(2);
          } else return Number(item.selectedSizes[0].price).toFixed(2);
        } else {
          return 'Sold Out';
        }
      }
    } else {
      if (item.isAvailable) return '';
      else return 'Sold Out';
    }
  };

  renderSpinner() {
    if (!this.state.popularMenuItems || this.state.renderedAll === false) {
      return (
        <div className='loadBoxWrap' style={{ padding: '19px 14px 0px' }}>
          {[...Array(21)].map((_, index) => {
            return (
              <div
                className='loadPlace itemBoxes'
                style={{
                  backgroundImage: `url(
                    'https://assets.nextorder.co/assets/placeholder.jpg'
                  )`,
                }}
                key={index}
              >
                <div>
                  <img src={placeholder} alt='Loading' />
                </div>
              </div>
            );
          })}
        </div>
      );
    }
  }

  renderMenuItems = () => {
    return (
      <div className='itemWrap2 tabsSlider--tabsWrapper' key='1'>
        {this.renderSpinner()}
        <NewMenuItem
          data={this.state.popularMenuItems}
          history={this.props.history}
          location={this.props.location}
          showMenuItemHandler={this.props.showMenuItemHandler}
          price={this.getPriceForDisplay}
          slideIndex={0}
          itemType='menuitem'
          activeSlideIndex={this.props.slideIndex}
          key={'mdd-' + 0}
        />
      </div>
    );
  };

  render() {
    return <div className={'itemWrap'}>{this.renderMenuItems()}</div>;
  }
}

MenuItems.propTypes = {
  menuCategories: PropTypes.any,
  allMenuItems: PropTypes.any,
  showMenuItemHandler: PropTypes.any,
  showHalfViewHandler: PropTypes.any,
  showSpecialsHandler: PropTypes.any,
  showHalfItem: PropTypes.any,
  selectedHalfItems: PropTypes.any,
  history: PropTypes.any,
};

export default MenuItems;
